import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=f1ec2a1e&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ec2a1e')) {
      api.createRecord('f1ec2a1e', component.options)
    } else {
      api.reload('f1ec2a1e', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=f1ec2a1e&", function () {
      api.rerender('f1ec2a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Q6zFLTDY9BE1/JS/comp/FavElement.vue"
export default component.exports